const createTheme = (breakpoints, isDarkMode) => {
  const darkModePrimaryColor = "#252C47";
  const darkModeSecondaryColor = "#2B3457";
  const darkModeBorderColor = "#3c497d";
  const darkModeBackground = "#0E142B";

  return {
    theme: {
      palette: {
        type: isDarkMode ? "dark" : "light",
        background: {
          default: isDarkMode ? darkModeBackground : "#fff",
          paper: isDarkMode ? darkModePrimaryColor : "#fff",
        },
        primary: {
          light: "#75b8ff",
          main: "#3289ef",
          dark: "#005dbc",
          contrastText: "#fff",
        },
        secondary: {
          light: "#67ffff",
          main: "#0cd3cd",
          dark: "#00a19c",
          contrastText: "#000",
        },
        error: {
          light: "#d16952",
          main: "#9b3b29",
          dark: "#670800",
          contrastText: "#fff",
        },
      },
      overrides: {
        MuiFormLabel: {
          root: {
            "&$focused": {
              color: "#8790a6",
            },
            "&$filled": {
              color: "#8790a6",
              marginTop: 8,
            },
          },
        },
        MuiFilledInput: {
          root: {
            backgroundColor: "#f7f8fd",
            marginRight: 18,
          },
        },
        MuiInputLabel: {
          root: {
            color: "#8790a6",
            fontSize: 16,
            fontWeight: 300,
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: 1.25,
            letterSpacing: 0.26,
            marginLeft: 24,
          },
        },
        MuiInputAdornment: {
          positionStart: {
            marginRight: 16,
            marginBottom: 12,
          },
          positionEnd: {
            marginBottom: 12,
          },
        },
        MuiTextField: {
          root: {
            justifyContent: "center",
            width: "100%",
            paddingLeft: 24,
            height: 72,
            color: "#181C1E",
            fontSize: 14,
            fontWeight: 300,
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: 1.31,
            letterSpacing: 0.26,
            borderRadius: 24,
            border: "solid 1px",
            borderColor: isDarkMode ? darkModeBorderColor : "#eaedf0",
            backgroundColor: isDarkMode ? darkModeSecondaryColor : "#f7f8fd",
            marginTop: 8,
          },
        },
        MuiInputBase: {
          root: {
            color: "#181C1E",
            fontSize: 14,
            fontWeight: 300,
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: 1.31,
            letterSpacing: 0.26,
            borderRadius: 24,
          },
        },
        MuiDialog: {
          paper: {
            borderRadius: 32,
            "-webkit-backdrop-filter": "blur(30px)",
            backdropFilter: "blur(30px)",
            boxShadow: "none",
            [breakpoints.down("xs")]: {
              width: "100%",
              height: "100%",
              borderRadius: 0,
              margin: 0,
            },
          },
          paperScrollPaper: {
            [breakpoints.down("xs")]: {
              maxHeight: "100%",
            },
          },
        },
        MuiDialogTitle: {
          root: {
            display: "flex",
            flexDirection: "row",
            paddingLeft: 48,
            paddingTop: 48,
            paddingBottom: 0,
          },
        },
        MuiDialogContent: {
          root: {
            paddingLeft: 48,
            paddingRight: 48,
            paddingTop: 36,
            paddingBottom: 16,
          },
        },
        MuiDialogActions: {
          root: {
            justifyContent: "center",
            backgroundColor: isDarkMode ? darkModeSecondaryColor : "#f7f8fd",
            padding: "32px 48px",
            borderTop: isDarkMode ? "none" : "solid 1px #eaedf0",
            //border: "solid 1px #eaedf0",
          },
        },
        MuiButton: {
          root: {
            backgroundColor: isDarkMode ? darkModePrimaryColor : "#fff",
            border: "1px solid",
            borderColor: isDarkMode ? darkModeBorderColor : "#E0E2E6",
            alignSelf: "center",
            width: "100%",
            height: 68,
            minWidth: 150,
            borderRadius: 24,
            marginTop: 16,
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#046bef",
            },
            boxShadow: "none",
          },
          contained: {
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
            },
            "&:active": {
              boxShadow: "none",
            },
          },
        },
        MuiFab: {
          root: {
            boxShadow: "none",
          },
        },
        MuiIconButton: {
          root: {
            //color: "#181C1E",
          },
        },
        MuiTooltip: {
          tooltip: {
            color: "#FFFFFF",
            backgroundColor: "#181C1E",
            borderRadius: 24,
            padding: "8px 16px",
          },
        },
        MuiAvatar: {
          colorDefault: {
            backgroundColor: isDarkMode ? darkModeSecondaryColor : "#F7F8FD", // dark mode #3C497D
            border: "1px solid",
            borderColor: isDarkMode ? darkModeBorderColor : "#EAEDF0",
            color: "#A7ADC8",
          },
        },
      },
    },
  };
};

export default createTheme;
